import './OldCarouselDotsStyles.css';
export const stylesOldCarousel = "s1524jdk";